const apiUrl = 'https://mtbapi.nf.validoapp.com';

export const environment = {
  production: false,
  api: {
    version: '20',
    url: apiUrl
  },
  legacyFrontend: {
    url: 'https://mtbappweb.nf.validoapp.com/'
  },
  customerForms: {
    domain: 'https://customer.humanstars.app'
  },
  customerHostRouting: {
    enabled: false,
    protocol: 'https',
    baseDomain: 'humanstars.app',
    defaultSubdomain: 'web'
  },
  firebase: {
    active: true,
    setupLogs: true,
    config: {
      apiKey: "AIzaSyD1Czsm35Ac9TIzPTa3mCz6EXn8-FdWt3U",
      authDomain: "valido-mitarbeiter-app.firebaseapp.com",
      databaseURL: "https://valido-mitarbeiter-app.firebaseio.com",
      projectId: "valido-mitarbeiter-app",
      storageBucket: "valido-mitarbeiter-app.appspot.com",
      messagingSenderId: "247044795998",
      appId: "1:247044795998:web:c0d930c2e50da816e24ecf",
      measurementId: "G-4PHW4RYSMM"
    }
  },
  sentry: {
    environment: 'development',
    traceSampleRate: 1.0,
    traceTargets: [apiUrl, 'localhost', /^\/api\//],
    replaySampleRate: 0.0,
  },
  writeSocketDebugLogs: true,
  tokenRefreshRemainingSeconds: 300
};
